import { RootState } from '../index'

export const selectTimeslots = (state: RootState) => state.timeslots
